import {
  type ConfigurableServer,
  notEmpty,
  type Optional,
} from '@festina-life/core'
import { useMemo } from 'react'

import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'

export const useExistentWorkspaceNames = (
  server: Optional<ConfigurableServer>,
) => {
  const { conciseWorkspaces } = useWorkspaceManagerContext()
  return useMemo(
    () =>
      server
        ? (conciseWorkspaces?.[server]
            ?.map((spec) => spec?.name)
            .filter(notEmpty) ?? [])
        : [],
    [server, conciseWorkspaces],
  )
}
